import moment from 'moment';

/**
 * Ready-made mask/validate/placeholder bundles for common patterns.
 * Spread into MaskedInput: `<MaskedInput {...MASK_PRESETS.dateMDY} value={...} onValueChange={...} />`
 */
export const MASK_PRESETS = {
	dateMDY: {
		mask: '99/99/9999',
		placeholder: 'MM/DD/YYYY',
		validate: (value: string) => moment(value, 'MM/DD/YYYY', true).isValid(),
	},
} as const;
